













import { computed, defineComponent, toRefs } from '~/utils/nuxt3-migration'
import { DYNAMIC_FORM_FIELD_PROPS } from '~/constants/dynamic-form'
import { useDynamicForm } from '~/compositions/dynamic-form'
import { useDeps } from '~/compositions/dependency-container'
import FormValidationBuilder from '~/builders/form/FormValidationBuilder'
import { computeFieldState } from '~/utils/form'
import CFormError from '~/components/shared/configurable/form/CFormError.vue'

export default defineComponent({
  components: { CFormError },
  props: DYNAMIC_FORM_FIELD_PROPS,
  setup(props) {
    const { name, min, max } = toRefs(props)

    const { value, error, changeValue } = useDynamicForm(props)
    const [formValidationBuilder] = useDeps(FormValidationBuilder)

    function handleInput(text: string) {
      const numValue = Number(text)
      error.value = formValidationBuilder
        .new()
        .aboveMinNumber(min.value, numValue)
        .belowMaxNumber(max.value, numValue)
        .validate()
      changeValue(name.value, text)
    }

    const inputState = computed(() => computeFieldState(error.value))

    return { handleInput, value, error, inputState }
  }
})
